// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"35d19853","406":"35d19853"}[chunkId] + ".chunk.css";
};